import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-745590c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "full-sidebar d-flex flex-column" }
const _hoisted_2 = {
  key: 0,
  class: "vrt-body"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "vrt-title" }, "How do you want to be notified?", -1))
const _hoisted_4 = { class: "vrt-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VirtualRedTagHeader = _resolveComponent("VirtualRedTagHeader")!
  const _component_VirtualRedTagMethodIcon = _resolveComponent("VirtualRedTagMethodIcon")!
  const _component_fbx_button = _resolveComponent("fbx-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VirtualRedTagHeader, { outlined: "" }),
    (_ctx.assessmentId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_fbx_button, {
              "button-text": "Email Me",
              theme: "primaryOutline",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.chooseMethod(_ctx.NotificationMethod.email)))
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_VirtualRedTagMethodIcon, {
                  method: "email",
                  class: "vrt-button-icon"
                })
              ]),
              _: 1
            }),
            _createVNode(_component_fbx_button, {
              "button-text": "Text Me",
              theme: "primaryOutline",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.chooseMethod(_ctx.NotificationMethod.text)))
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_VirtualRedTagMethodIcon, {
                  method: "text",
                  class: "vrt-button-icon"
                })
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_fbx_button, {
            "button-text": "Return to Pointe",
            theme: "link",
            class: "italic vrt-return-link",
            onClick: _ctx.navigateToWelcome
          }, null, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true)
  ]))
}